import { render, staticRenderFns } from "./ScheduleWeekCol.vue?vue&type=template&id=2ea1c72b&scoped=true&"
import script from "./ScheduleWeekCol.vue?vue&type=script&lang=js&"
export * from "./ScheduleWeekCol.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleWeekCol.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ScheduleWeekCol.vue?vue&type=style&index=1&id=2ea1c72b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1c72b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
